module.exports = __webpack_public_path__ + "static/media/excercies-image@2x.568b5f5f.png";